module.exports = __webpack_public_path__ + "fonts/51defa9da4177a5e7b59e1f343614494.svg";